import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-post-property-alert',
  templateUrl: './post-property-alert.component.html',
  styleUrls: ['./post-property-alert.component.css']
})
export class PostPropertyAlertComponent implements OnInit {

  constructor( private router: Router) { }

  ngOnInit(): void {
  }

  openModal(): void {
    // Logic to open the modal
    const modal = document.querySelector('.modal');
    if (modal) {
      modal.classList.add('show');
      modal.setAttribute('style', 'display: block;');
    }
  }

  closeModal(): void {
    // Logic to close the modal
    const modal = document.querySelector('.modal');
    if (modal) {
      modal.classList.remove('show');
      modal.setAttribute('style', 'display: none;');
    }
  }

  postNow(): void {
    this.navigateIfDifferent('/m/post-request');
  }

  private navigateIfDifferent(route: string): void {
    if (this.router.url !== route) {
      this.router.navigate([route]);
    }
  }

  skip(): void {
    // Close the modal or handle skipping action
    this.closeModal();
    // your logic
  }
}
